import React from 'react';
import TeamRostersTable from './TeamRostersTable';

type Roster = {
  player_id: string;
  player_name: string;
  position: string;
  class?: string;
  jersey?: string | number;
};

interface RostersTableProps {
  homeRosters: Roster[];
  oppRosters: Roster[];
  homeTeamName?: string;
  homeTeamCode?: number;
  oppTeamName?: string;
  oppTeamCode?: number;
}

const RostersTable: React.FC<RostersTableProps> = ({
  homeRosters,
  oppRosters,
  homeTeamName,
  homeTeamCode,
  oppTeamName,
  oppTeamCode,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <TeamRostersTable roster={homeRosters} teamName={homeTeamName} teamCode={homeTeamCode} />
    <TeamRostersTable roster={oppRosters} teamName={oppTeamName} teamCode={oppTeamCode} />
  </div>
);

export default RostersTable;
